<template>
  <div class="hold-transition">
    <Loading v-if="cargando" />
    <div class="wrapper">
      <div class="content-wrapper">
        <section class="content-header">
          <div class="container-fluid">
            <div class="row">
              <div class="col-sm-6">
                <h5 class="mb-0">Tarifarios</h5>
              </div>
              <div class="col-sm-6">
                <ol class="breadcrumb float-sm-right">
                  <li class="breadcrumb-item">
                    <router-link to="/">Home</router-link>
                  </li>
                  <li class="breadcrumb-item active">Hidrocarburos</li>
                  <li class="breadcrumb-item active">Tarifarios</li>
                </ol>
              </div>
            </div>
          </div>
        </section>
        <section class="content">
          <div class="container-fluid">
            <div class="card">
              <div class="card-header pt-2 pb-2">
                <div class="row">
                  <div class="col-md-11"></div>
                  <div class="col-md-1">
                    <div class="btn-group float-right">
                      <button
                        type="button"
                        class="btn btn-primary"
                        @click="create()"
                        v-if="
                          $store.getters.can('hidrocarburos.tarifarios.create')
                        "
                      >
                        <i class="fas fa-plus"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <!-- /.card-header -->
              <div class="card-body p-0">
                <table
                  class="
                    table table-bordered table-striped table-hover table-sm
                  "
                >
                  <thead>
                    <tr>
                      <th>
                        Nombre
                        <input
                          type="text"
                          class="form-control form-control-sm"
                          v-model="filtros.nombre"
                          @keyup.enter="getIndex()"
                        />
                      </th>
                      <th>
                        Empresa
                        <v-select
                          class="form-control form-control-sm p-0"
                          placeholder="Empresa"
                          label="razon_social"
                          v-model="empresa"
                          :options="listasForms.empresas"
                          @input="selectEmpresa()"
                        ></v-select>
                      </th>
                      <th class="text-center">Observaciones</th>
                      <th style="width: 150px">
                        Estado
                        <select
                          class="form-control form-control-sm"
                          v-model="filtros.estado"
                          @change="getIndex()"
                        >
                          <option value="">Todos...</option>
                          <option
                            v-for="estado in listasForms.estados"
                            :key="estado.numeracion"
                            :value="estado.numeracion"
                          >
                            {{ estado.descripcion }}
                          </option>
                        </select>
                      </th>
                      <th class="text-center">
                        <label for="">Acción</label>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="tarifario in tarifarios.data"
                      :key="tarifario.id"
                    >
                      <td>{{ tarifario.nombre }}</td>
                      <td>{{ tarifario.empresa.razon_social }}</td>
                      <td>{{ tarifario.observaciones }}</td>
                      <td class="text-center">
                        <span
                          class="badge"
                          v-bind:class="[
                            tarifario.estado == 1
                              ? 'badge-warning'
                              : 'badge-success',
                          ]"
                        >
                          {{
                            tarifario.estado == 1 ? "Borrador" : "Definitivo"
                          }}
                        </span>
                      </td>
                      <td class="text-center">
                        <div class="btn-group">
                          <button
                            type="button"
                            class="btn btn-sm bg-navy"
                            v-if="
                              $store.getters.can(
                                'hidrocarburos.tarifarios.show'
                              )
                            "
                            @click="edit(tarifario)"
                          >
                            <i class="fas fa-edit"></i>
                          </button>
                          <button
                            type="button"
                            class="btn btn-sm btn-danger"
                            v-if="
                              $store.getters.can(
                                'hidrocarburos.tarifarios.delete'
                              )
                            "
                            :disabled="tarifario.estado != 1"
                            @click="destroy(tarifario.id)"
                          >
                            <i class="fas fa-trash-alt"></i>
                          </button>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="card-footer">
                <div class="float-left" v-if="tarifarios.total">
                  <p>
                    Mostrando del <b>{{ tarifarios.from }}</b> al
                    <b>{{ tarifarios.to }}</b> de un total:
                    <b>{{ tarifarios.total }}</b> Registros
                  </p>
                </div>
                <div class="float-left" v-else>
                  <p>
                    <span class="badge badge-danger">
                      No hay registros para mostrar
                    </span>
                  </p>
                </div>
                <pagination
                  :data="tarifarios"
                  @pagination-change-page="getIndex"
                  :limit="5"
                  align="right"
                ></pagination>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import vSelect from "vue-select";
import pagination from "laravel-vue-pagination";
import Loading from "../../../../components/Loading";

export default {
  name: "TarifariosIndex",
  components: {
    vSelect,
    pagination,
    Loading,
  },
  data() {
    return {
      storageKeyFiltros: 'hidrocarburos_tarifario_filtros',
      cargando: false,
      tarifarios: {},
      empresa: {},
      listasForms: {
        estados: [],
        empresas: [],
      },
      filtros: {
        nombre: null,
        empresa_id: null,
        estado: null,
      },
    };
  },
  methods: {
    getStoredFiltros() {
      try {
        const raw = sessionStorage.getItem(this.storageKeyFiltros);
        return raw ? JSON.parse(raw) : null;
      } catch (e) {
        return null;
      }
    },
    setStoredFiltros() {
      try {
        const payload = {
          filtros: { nombre: this.filtros.nombre, empresa_id: this.filtros.empresa_id, estado: this.filtros.estado },
          empresa: this.empresa && this.empresa.id ? { id: this.empresa.id, razon_social: (this.empresa.razon_social || '') } : null,
        };
        sessionStorage.setItem(this.storageKeyFiltros, JSON.stringify(payload));
      } catch (e) {
        // sessionStorage no disponible
      }
    },
    clearStoredFiltros() {
      try {
        sessionStorage.removeItem(this.storageKeyFiltros);
      } catch (e) {
        // sessionStorage no disponible
      }
    },
    getIndex(page = 1) {
      this.cargando = true;
      const stored = this.getStoredFiltros();
      if (stored) {
        this.filtros.nombre = stored.filtros.nombre ?? null;
        this.filtros.empresa_id = stored.filtros.empresa_id ?? null;
        this.filtros.estado = stored.filtros.estado ?? null;
        this.empresa = stored.empresa || null;
        this.clearStoredFiltros();
      } else {
        this.filtros.empresa_id = null;
        if (this.empresa) {
          this.filtros.empresa_id = this.empresa.id;
        }
      }
      axios
        .get("/api/hidrocarburos/tarifarios?page=" + page, {
          params: this.filtros,
        })
        .then((response) => {
          this.tarifarios = response.data;
          this.cargando = false;
        })
        .catch((e) => {
          this.cargando = false;
          this.$swal({
            icon: "error",
            title: "Ocurrió un error: " + e,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        });
    },

    getEmpresas() {
      axios.get("/api/admin/empresas/lista").then((response) => {
        this.listasForms.empresas = response.data;
      });
    },

    getEstados() {
      axios.get("/api/lista/28").then((response) => {
        this.listasForms.estados = response.data;
      });
    },

    selectEmpresa() {
      this.filtros.empresa_id = null;
      if (this.empresa) {
        this.filtros.empresa_id = this.empresa.id;
      }
      this.getIndex();
    },

    destroy(idTarifario) {
      this.$swal({
        title: "Esta seguro de eliminar esta Contrato?",
        text: "Los cambios no se pueden revertir!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Si, Eliminar!",
      }).then((result) => {
        if (result.value) {
          axios
            .delete("/api/hidrocarburos/tarifarios/" + idTarifario)
            .then(() => {
              this.getIndex();
              this.$swal({
                icon: "success",
                title: "Se elimino la Contrato exitosamente...",
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 4000,
                timerProgressBar: true,
              });
            });
        }
      });
    },

    create() {
      return this.$router.push({
        name: "/Hidrocarburos/TarifarioForm",
        params: { accion: "Crear", id: null },
      });
    },

    edit(tarifario) {
      this.setStoredFiltros();
      return this.$router.push({
        name: "/Hidrocarburos/TarifarioForm",
        params: {
          accion: "Editar",
          data_edit: tarifario,
          id: tarifario.id,
        },
      });
    },
  },
  mounted() {
    this.getIndex();
    this.getEstados();
    this.getEmpresas();
  },
};
</script>
